import { Checkbox } from '@material-ui/core';
// import { AutocompleteRenderOptionState } from '@material-ui/lab/Autocomplete';
// import { useCategorySections } from 'app/business-app/views/business-profile/UpdateRepairCapabilities';
import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
// import { UrlQueryKey } from 'app/core/api/api-core/api-constants';
import {
  useCreateCustomProduct,
  useProductBrands,
  useProductCategoriesByBrand,
} from 'app/core/api/product/api-product';
import {
  ProductBrand,
  ProductCategory,
} from 'app/core/api/product/api-product.types';
import Button from 'app/shared/components/button/Button';
import FormAutocomplete, {
  CreatedOpt,
  isCreatedOpt,
} from 'app/shared/components/form-input/FormAutocomplete';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
// import Icon from 'app/shared/components/icon/Icon';
// import IconLib from 'app/shared/components/icon/icon-lib';
import { DetailedGroup } from 'app/shared/components/list/TreeSelectList';
import VirtualizedList from 'app/shared/components/list/VirtualizedList';
import { ErrorText, PadCollapse } from 'app/shared/components/misc';
import Body from 'app/shared/components/typography/body/Body';
import Subheading from 'app/shared/components/typography/subheading/Subheading';
import Form from 'app/shared/frames/Form';
import { isNonNullable } from 'app/tools/general.types';
// import { getHistoryLocationObj } from 'app/tools/utils';
// import clsx from 'clsx';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react'; // SyntheticEvent
import { useHistory } from 'react-router-dom';
import { tap } from 'rxjs';
import { useAssignProductBlank } from 'app/core/api/product-assignment/api-product-assignment';
import { AssignProductReqBlank } from 'app/core/api/product-assignment/api-product-assignment.types';
// NOTE: ------ Legend for category nomenclature ------
// category:       generic term for a category of any level
// cat, catg:      shorthand for category (sometimes used in compound variable names)

// parent:         term for the category one higher and directly related to the category being described
// child:          term for the category one lower and directly related to the described category

// area:           top level category (has no parents)
// group:          mid level category (always has parents that are areas, can have children)
// childlessGroup: mid level category with no children
// variant:        bottom level category (always has parents that are groups, never has children)

// highlighted:    the item in question has the highlight bar on it in a autocomplete but is not selected yet
// selected:       the item in question has been chosen and set as the current option, auto-filling the text box

// categoryTreeItem:  either a group or variant level category with extra information to display in a tree list
// xToY:              a function that converts type x objects into type y objects
// parentGroup:       a field on a category object indicating the id of the object's parent (parent must be a
//                    group-level category). Field will be undefined if there is no parent that is group-level.
// areaWithGroups:    an object that collects group-level catgs by their parent area. Has one area and an array
//                    of the groups that have that area as their parent.

type FormValues = {
  model: string;
  category: CategoryTreeItem | CreatedOpt;
  brand: ProductBrand | CreatedOpt;
};

/**
 * @param input either a selected category (must have an id field),
 * or a 'created option' object, returned from MuiAutocomplete
 * @returns either the id of item selected (a number), or the input
 * value of the custom entry item entered (a string)
 */
const getIdOrInputValue = (
  input: { id: number } | CreatedOpt
): string | number =>
  isCreatedOpt(input) ? input.inputValue : input.id;

// const getParentName = (
//   parents: { id: number; displayName: string }[],
//   child: { parent?: number }
// ): string =>
//   parents.find(p => p.id === child?.parent)?.displayName ||
//   'Miscellaneous';

const useVariantsAndChildlessGroups = (
  categories: ProductCategory[]
): ProductCategory[] =>
  useMemo(() => {
    const areaIds = _(categories)
      .filter(c => !c.parent)
      .map('id')
      .value();
    const groupIds = _(categories)
      .filter(c => areaIds.includes(c.parent || -1))
      .map('id')
      .value();
    const variantCatgs = categories.filter(c =>
      groupIds.includes(c.parent || -1)
    );
    const variantParentIds = variantCatgs
      .map(v => v.parent)
      .filter(isNonNullable);
    const childlessGroupCatgs = categories.filter(
      c => groupIds.includes(c.id) && !variantParentIds.includes(c.id)
    );
    return _(variantCatgs.concat(childlessGroupCatgs))
      .sortBy(c => c.displayName.toLowerCase())
      .value();
  }, [categories]);

export type AreaWithGroups = {
  area: string;
  groups: DetailedGroup<ProductCategory>[];
};
export type CategoryTreeItem = {
  id: number;
  displayName: string;
  area: string;
  parentGroup?: number;
  expanded?: boolean;
};
export type BrandCategoryTreeItem = {
  id: number;
  categoryName: string;
};

const areaWithGroupsToCatTreeItems = ({
  area,
  groups,
}: AreaWithGroups): CategoryTreeItem[] => {
  const sortedGroups = _.sortBy(groups, 'displayName');
  const sortedDeep = sortedGroups.map(g => ({
    ...g,
    variants: _.sortBy(g.variants, 'displayName'),
  }));
  return sortedDeep
    .map(c => [
      {
        ..._.pick(c, 'id', 'displayName'),
        // group-level, so needs this to track expanded status in tree
        expanded: c.variants.length ? false : undefined,
      },
      ...c.variants.map(v => ({
        ..._.pick(v, 'id', 'displayName'),
        // variant-level, so needs to know parent to check if expanded
        parentGroup: v.parent,
      })),
    ])
    .flat()
    .map(c => ({ ...c, area }));
};

export default function ManualProductEntry(): JSX.Element {
  const history = useHistory();
  const { request$: assignProductBlank$ } = useAssignProductBlank();
  // const { resource: allCategories = [] } = useProductCategories();
  const { resource: brands } = useProductBrands();
  const {
    resource: brandCategories = [],
    request: getProductCategoriesByBand$,
    // loading: loadingMissingAddress,
  } = useProductCategoriesByBrand();

  // const [catgFilterPresent, setCatgFilterPresent] = useState(false);

  // const { allGroupsCurrentDetails, allAreas } = useCategorySections({
  //   allCategories,
  // });

  // const [catTreeItemList, setCatTreeItemList] = useState<
  //   CategoryTreeItem[]
  // >([]);

  const [brandCatTreeItemList, setBrandCatTreeItemList] = useState<
    BrandCategoryTreeItem[]
  >([]);

  // useEffect(() => {
  //   const processedList = _(allGroupsCurrentDetails)
  //     .groupBy(g => getParentName(allAreas, g))
  //     .entries()
  //     .map(([k, v]) => ({ area: k.toUpperCase(), groups: v }))
  //     .sortBy('area')
  //     .map(areaWithGroupsToCatTreeItems)
  //     .flatten()
  //     .value();
  //   setCatTreeItemList(processedList);
  // }, [allAreas, allGroupsCurrentDetails]);

  useEffect(() => {
    getProductCategoriesByBand$(0);
  }, [getProductCategoriesByBand$]);

  useEffect(() => {
    setBrandCatTreeItemList(brandCategories);
  }, [brandCategories]);

  // const [highlightedCatg, setHighlightedCatg] =
  //   useState<CategoryTreeItem | null>(null);

  const {
    request$: createCustomProduct$,
    sending,
    error,
  } = useCreateCustomProduct();

  // watch
  const { inputProps, handleSubmit } = useInputForm<FormValues>({
    apiError: error,
  });
  // const selectedCatg = watch('category');

  const submit = ({ model, category, brand }: FormValues) =>
    createCustomProduct$({
      model,
      category: getIdOrInputValue(category),
      brand: getIdOrInputValue(brand),
    }).pipe(
      tap(product => {
        const productIdentifier: AssignProductReqBlank = {
          upcProductId: product.id.toString(),
        };
        assignProductBlank$(productIdentifier).subscribe(res => {
          history.push(
            `${ConsumerRoutePath.VIEW_ASSIGNED_PRODUCT}/${res.id}`
          );
        });

        // const locationObj = getHistoryLocationObj({
        //   pathname: `${ConsumerRoutePath.ADD_ASSIGNED_PRODUCT_DETAILS}`,
        //   query: {
        //     [UrlQueryKey.PRODUCT_VARIANT_ID]: product.id,
        //     [UrlQueryKey.PRODUCT_VARIANT_NAME]: product.name,
        //   },
        // });
        // if (locationObj) history.push(locationObj);
      })
    );

  // const shouldBeHidden = (o: CategoryTreeItem): boolean => {
  //   const parent = catTreeItemList.find(c => c.id === o.parentGroup);
  //   return parent?.expanded === false && !catgFilterPresent;
  // };

  // const hasChildren = (o: CategoryTreeItem): boolean =>
  //   isNonNullable(o.expanded);

  /**
   * Intercepts the click / enter press that would normally select an
   * item, and handles it differently based on the item. If it is a
   * group with variants, it will instead toggle the group expand/collapse
   * @param evt the synthetic event being captured
   * @param targetCatg optional, specifying the item that received the
   * action. Only available from the click event, so key press falls back
   * to the highlightedCatg state.
   */
  // const handleSelectTriggered = (
  //   evt: SyntheticEvent,
  //   targetCatg?: CategoryTreeItem
  // ) => {
  //   // prioritise specific catg passed, else fallback to highlighted catg
  //   const o = targetCatg || highlightedCatg;
  //   if (!o) return; // no target item, do nothing
  //   if (hasChildren(o)) {
  //     evt.stopPropagation();
  //     evt.preventDefault();
  //     setCatTreeItemList(s =>
  //       s.map(c =>
  //         c.id === o.id ? { ...c, expanded: !c.expanded } : c
  //       )
  //     );
  //   }
  // };

  /** This is called whenever the popup opens, to ensure the selected
   * category is always visible to start with (and will be able to auto-
   * scroll to display it properly)
   */
  // const expandSelectedOptionParent = () =>
  //   setCatTreeItemList(s =>
  //     s.map(c =>
  //       !isCreatedOpt(selectedCatg) &&
  //       c.id === selectedCatg?.parentGroup
  //         ? { ...c, expanded: true }
  //         : c
  //     )
  //   );

  // const renderTreeOption = (
  //   o: CreatedOpt | CategoryTreeItem,
  //   { selected }: AutocompleteRenderOptionState
  // ) =>
  //   isCreatedOpt(o) ? (
  //     <ListItemText className="flex justify-start items-center py-0.5 px-1.5 m-0 w-full h-[48px]">
  //       {/* NOTE: Checkbox is here only to provide visual continuity
  //       with the list options */}
  //       <Checkbox />
  //       {o.title}
  //     </ListItemText>
  //   ) : (
  //     <div
  //       // 'presentation' tells screen readers to ignore this div
  //       // (they will use the parent list item instead for keyboard
  //       // navigation). This has to exist to attack the onClick method
  //       role="presentation"
  //       onClick={evt => handleSelectTriggered(evt, o)}
  //       className={clsx(
  //         'flex overflow-y-hidden justify-start items-center px-1.5 w-full transition-all',
  //         shouldBeHidden(o)
  // //           ? 'py-0 h-0 opacity-0'
  //           : 'py-0.5 opacity-100 h-[48px]',
  // //         !o.parentGroup && (hasChildren(o) ? 'ml-1' : '-ml-[32px]')
  //       )}
  //     >
  //       {!hasChildren(o) && <Checkbox checked={selected} />}
  //       <div className="grow">{o.displayName}</div>
  //       {hasChildren(o) && (
  //         <Icon
  //           className={clsx(
  //             'transition rotate-0',
  //             o.expanded && 'rotate-180'
  //           )}
  //           icon={IconLib.CHEVRON_DOWN}
  //         />
  //       )}
  //     </div>
  //   );

  const handleBrandSelect = (option: string) => {
    if (option !== '' && brands?.length) {
      const brand: ProductBrand = brands.filter(
        item => item.displayName === option
      )[0];
      if (brand) {
        getProductCategoriesByBand$(brand.id);
      } else {
        setBrandCatTreeItemList([]);
      }
    }
  };

  return (
    <>
      <Subheading
        centered={false}
        color="primary"
        style={{ fontWeight: 500 }}
      >
        Enter the basic details for your product here.
      </Subheading>
      <Body>
        This will be used to link your product to warranties, and to
        repairers if you require a repair for your product.
      </Body>
      <PadCollapse pad={2} />
      <Form onSubmit={handleSubmit(submit)} css="flex-grow: 1">
        <FormAutocomplete
          controlName="brand"
          TextInputProps={{
            placeholder: 'Brand name',
          }}
          freeSolo
          autoHighlight
          forcePopupIcon
          options={brands || []}
          getOptionLabel={o =>
            isCreatedOpt(o) ? o.inputValue : o.displayName
          }
          ListboxComponent={VirtualizedList}
          {...inputProps}
          // onChange={(event: unknown, newValue: string | null) => {
          //   handleBrandSelect(newValue);
          // }}
          onInputChange={(event, newInputValue) => {
            handleBrandSelect(newInputValue);
          }}
        />
        <FormAutocomplete
          controlName="category"
          freeSolo
          autoHighlight
          forcePopupIcon
          // onOpen={expandSelectedOptionParent}
          // options={catTreeItemList}
          options={brandCatTreeItemList || []}
          // onInput={event =>
          //   setCatgFilterPresent(!!_(event).get('target.value'))
          // }
          getOptionLabel={o =>
            isCreatedOpt(o) ? o.inputValue : o.categoryName
          }
          renderOption={(o, { selected }) => (
            <>
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {isCreatedOpt(o) ? o.inputValue : o.categoryName}
            </>
          )}
          // getOptionLabel={o => {
          //   if (isCreatedOpt(o)) return o.inputValue;
          //   const parent = catTreeItemList.find(
          //     c => c.id === o.parentGroup
          //   );
          //   return [parent?.displayName || [], o.displayName]
          //     .flat()
          //     .join(' - '); // display in format 'Cameras - Accessories'
          // }}
          // groupBy={o => (!isCreatedOpt(o) ? o.area : 'Custom')}
          // onHighlightChange={(...[, o]) => {
          //   if (o === null || !isCreatedOpt(o)) setHighlightedCatg(o);
          // }}
          // renderOption={renderTreeOption}
          // TextInputProps={{
          //   onKeyDown: evt => {
          //     if (evt.key === 'Enter') handleSelectTriggered(evt);
          //   },
          // }}
          classes={{ option: 'p-0 min-h-0', groupLabel: 'uppercase' }}
          {...inputProps}
        />
        {/* <FormAutocomplete
          controlName="category"
          options={brandCatTreeItemList || []}
          getOptionLabel={option => option.categoryName}
          disableCloseOnSelect
          disableClearIcon
          disabled={!currentCapabilities || !editable}
          autoHighlight
          multiple
          getOptionSelected={(opt, val) => opt.id === val.id}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.categoryName}
            </>
          )}
          TextInputProps={renderProps => {
            const selected = renderProps.InputProps.startAdornment;
            const anySelected =
              _.isArray(selected) && selected.length;
            return {
              placeholder: anySelected
                ? `${anySelected} selected. Add more..`
                : 'Choose categories',
              label: 'categories',
              greyPlaceholder: true,
              // TODO: Improve. Atm, Autocomplete has a default 9px padding around input.
              minHeight: 57 - 9 * 2,
            };
          }}
          {...inputProps}
        /> */}

        <FormTextInput
          controlName="model"
          label="Product model name"
          placeholder={`e.g. ${
            ['Galaxy S10', 'iPhone 13 Pro', 'Pixel 2', 'Watch 3'][
              _.random(3, false)
            ]
          }`}
          {...inputProps}
        />
        <ErrorText message={error} />
        <PadCollapse pad={2} />
        <Button type="submit" pending={sending}>
          Next
        </Button>
      </Form>
    </>
  );
}

export const exportForTesting = {
  useVariantsAndChildlessGroups,
  areaGroupToCatTreeItems: areaWithGroupsToCatTreeItems,
};
